import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()
const SUCURSALES="sucursales"

export const sucursalesGet = (params) => {
	const controller= loadAbort()
	const call= axios.get(SUCURSALES,{params,signal:controller.signal})
	return {call,controller}
}
